import { AccordionDetails, Typography, styled } from "@mui/material";

export const Styled = {
    Heading: styled(Typography)`
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
    `,
    Bold: styled("span")`
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
    `,
    AccordionDetails: styled(AccordionDetails)`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};
